export default "__VITE_ASSET__m3EYm1UE__"